import React, { useCallback, useEffect, useRef, useState } from "react";
import rightArrow from "../../../assets/images/icons/rightArrow.png";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import MainFabric from "./tabs/MainFabric.tabs";
import Personalize from "./tabs/Personalize.tabs";
import {
  Link,
  NavLink,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import Konva from "konva";
import {
  Stage,
  Layer,
  Text,
  Image as KonvaImage,
  Transformer,
  TextPath,
} from "react-konva";
import axios from "axios";
import Constants from "../../Variables/Constants";
import { toast } from "react-toastify";
import Design from "./tabs/Design.tabs";
import Fabric2 from "./tabs/SecondaryFabric.tabs";

import { useDispatch } from "react-redux";
import Loader from "../../../components/Loader";
import LoginModal from "../../../components/LoginModal";
import "./css/index.css";
import { getUniqueId, matchingData } from "../../../utils";
import { FaShoppingCart } from "react-icons/fa";
import ProductsList from "../ProductsList";
import { AddOnTabContent } from "./tabs/AddOn.tabs";
import { Rectangle } from "./components/Kanvas";
import { ThreadColorTabContent } from "./tabs/ThreadColor.tabs";
import { SizeTabContent } from "./tabs/Size.tabs";
import {
  calculateFontSize,
  createDefaultTextObject,
  formatMixedHebrewText,
  HEX_COLOR,
  hexToRgba,
  MAX_HISTORY,
  optionArr,
  strapArr,
} from "./components/Customize.constant";
import {
  addToCart,
  fetchAddOns,
  fetchCart,
  fetchDesigns,
  fetchPersonalizeColorList,
  getAllFabric,
  getCategoryDetail,
  getCollectionDetail,
  getCollectionList,
  getCustomization,
  getFabricData,
  getSingleProduct,
  handleSizeData,
} from "./components/Customize.api";

const Customize = () => {
  const dispatch = useDispatch();
  const [searchParams, setSearchParam] = useSearchParams();
  const navigate = useNavigate();
  const stageRef = useRef(null);
  const originalCanvasRef = useRef(null);
  const modifiedCanvasRef = useRef(null);
  const containerCanvasRef = useRef(null);
  const textRefs = useRef({});
  const transformerRefs = useRef({});

  const [productId, setProductId] = useState(null);
  const [isEditable, setIsEditable] = useState(null);
  const [customizeImageId, setCustomizeImageId] = useState(null);
  const [isComparedButtonEnabled, setIsComparedButtonEnabled] = useState(false);
  const [konvaImage1, setKonvaImage1] = useState(null);
  const [fabricData, setFabricData] = useState([]);
  const [baseImageUrl, setBaseImageUrl] = useState("");
  const [fillImageUrl, setFillImageUrl] = useState("");
  const [bgColor, setBgColor] = useState(null);
  const [activeMenuTab, setActiveMenuTab] = useState("Main Fabric");
  const [cartBtnMsg, setCartBtnMsg] = useState("Add To Cart");
  const [mainFabricId, setMainFabricId] = useState("");
  const [product, setProduct] = useState(null);
  const [fabric2Id, setFabric2Id] = useState("");
  const [getFabricImage, setFabricImage] = useState([]);
  const [getFabric2Image, setFabric2Image] = useState([]);
  const [textObjects, setTextObjects] = useState([]);
  const [rectangles, setRectangles] = React.useState([]);
  const [designData, setDesignData] = useState(null);
  const [letterCount, setLetterCount] = useState(0);
  const [textTransformers, setTextTransformers] = useState({});
  const [designImageId, setDesignImageId] = useState(null);
  const [art1DesignId, setArt1DesignId] = useState(null);
  const [art2DesignId, setArt2DesignId] = useState(null);
  const [currentArt1Design, setCurrentArt1Design] = useState([]);
  const [currentArt2Design, setCurrentArt2Design] = useState(null);
  const [art1Thread, setArt1Thread] = useState([]);
  const [art2Thread, setArt2Thread] = useState([]);
  const [selectedSize, setSelectedSize] = useState(null);
  const [sizeData, setSizeData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [totalTextPrice, setTotalTextPrice] = useState(0);
  const [loginModalIsOpen, setLoginModalIsOpen] = useState(false);
  const [selectedMatchingSize, setSelectedMatchingSize] = useState(
    matchingData[0],
  );
  const [totalPrice, setTotalPrice] = useState(0);
  const [sizeId, setSizeId] = useState(null);
  const [categoryId, setCategoryId] = useState("");
  const [collectionId, setCollectionId] = useState("");
  const [categoryData, setCategoryData] = useState("");
  const [collectionData, setCollectionData] = useState({});
  const [exportActionType, setExportActionType] = useState("compare");
  const [scaleCanvas, setScaleCanvas] = useState(1);
  const [selectedStrap, setSelectedStrap] = useState(strapArr[0]);
  const [selectedArt2Id, setSelectedArt2Id] = useState(null);
  const [collectionList, setCollectionList] = useState([]);
  const [getAllDesign, setAllDesign] = useState([]);
  const [designsLoading, setDesignLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const [historyStep, setHistoryStep] = useState(-1);
  const [selectedAddOns, setSelectedAddOns] = useState([]);
  const [totalAddOnPrice, setTotalAddOnPrice] = useState(0);
  const [hideDeleteButtons, setHideDeleteButtons] = useState(false);
  const [selectedArt1Option, setSelectedArt1Option] = useState(collectionData);
  const [addOns, setAddOns] = useState({
    loading: false,
    error: null,
    data: null,
  });
  const [colorList, setColorList] = useState([]);
  const [mainFabricList, setMainFabricList] = useState([]);
  const [activeMainTabState, setActiveMainTabState] = useState("Velvet");
  const [selectedMainTabData, setSelectedMainTabData] = useState([]);
  const [activeSecondaryTabState, setActiveSecondaryTabState] =
    useState("Velvet");
  const [selectedSecondaryTabData, setSelectedSecondaryTabData] = useState([]);
  const [refetchProducts, setRefetchProducts] = useState(false);
  const [selectedFabric2Data, setSelectedFabric2Data] = useState(null);
  const [notes, setNotes] = useState("");
  const [art2Quantities, setArt2Quantities] = useState({});

  // Dynamic canvas dimensions based on category
  const [dynamicCanvasWidth, setDynamicCanvasWidth] = useState(800);
  const [dynamicCanvasHeight, setDynamicCanvasHeight] = useState(600);

  useEffect(() => {
    getCollectionList({ setLoader, setCollectionList });
  }, []);
  useEffect(() => {
    getCategoryDetail({ categoryId, setLoader, setCategoryData });
    if (categoryId) {
      fetchPersonalizeColorList({ setColorList, categoryId });
      fetchAddOns({ setAddOns, categoryId });
      getAllFabric({
        setMainFabricList,
        setActiveTabState: [setActiveMainTabState, setActiveSecondaryTabState],
        setSelectedTabData: [setSelectedMainTabData, setSelectedSecondaryTabData],
        categoryId,
      });
    }
  }, [categoryId]);

  // Ensure tab data is set when mainFabricList loads
  useEffect(() => {
    if (mainFabricList && Object.keys(mainFabricList).length > 0) {
      // If no tab data is set, set it to the first tab's data
      if (!selectedMainTabData || selectedMainTabData.length === 0) {
        const firstTab = Object.keys(mainFabricList)[0];
        console.log("Setting initial main tab data:", firstTab);
        setActiveMainTabState(firstTab);
        setSelectedMainTabData(mainFabricList[firstTab] || []);
      }
      
      if (!selectedSecondaryTabData || selectedSecondaryTabData.length === 0) {
        const firstTab = Object.keys(mainFabricList)[0];
        console.log("Setting initial secondary tab data:", firstTab);
        setActiveSecondaryTabState(firstTab);
        setSelectedSecondaryTabData(mainFabricList[firstTab] || []);
      }
    }
  }, [mainFabricList]);

  useEffect(() => {
    const normalizedCategoryName = (categoryData?.title || categoryData?.name || "")
      .trim()
      .toLowerCase();
    const isChallahCover =
      normalizedCategoryName.includes("passover") ||
      normalizedCategoryName.includes("pesach") ||
      normalizedCategoryName.includes("challah");

    setDynamicCanvasWidth(600);
    setDynamicCanvasHeight(isChallahCover ? 430 : 600);
    // console.log(isChallahCover,"jjj")
    // Add default background rectangle for Challah Cover
    if (isChallahCover && rectangles.length === 0) {
      const defaultRectangle = {
        id: getUniqueId(),
        src: "https://cdn.builder.io/api/v1/image/assets%2Fada538515ba746128074e68e290db39a%2Fd324ec22cf40489b815eaa6c3e90337e?format=webp&width=800&height=1200",
        x: 0,
        y: 0,
        width: 600,
        height: 430,
        type: "background",
      };
      setRectangles([defaultRectangle]);
    }
  }, [categoryData?.title, categoryData?.name, rectangles.length]);

  const captureSnapshot = useCallback(() => {
    const currentState = {
      rectangles: JSON.parse(JSON.stringify(rectangles)),
      getFabricImage: getFabricImage.map((img) => ({
        id: img.id,
        x: img.x,
        y: img.y,
        width: img.width,
        height: img.height,
        src: img.image?.src,
      })),
      getFabric2Image: getFabric2Image.map((img) => ({
        id: img.id,
        x: img.x,
        y: img.y,
        width: img.width,
        height: img.height,
        src: img.image?.src,
      })),
      konvaImage1Src: konvaImage1?.src || null,
      textObjects,
      mainFabricId,
      fabric2Id,
      art1DesignId,
      art2DesignId,
      currentArt1Design,
      currentArt2Design,
      art1Thread,
      art2Thread,
      baseImageUrl,
      fillImageUrl,
      selectedStrap,
      totalTextPrice,
      selectedFabric2Data,
      fabricData, // Add main fabric selection state
      selectedSize, // Add selected size state
      selectedAddOns, // Add selected add-ons state
      // Tab selections
      activeMenuTab,
      activeMainTabState,
      activeSecondaryTabState,
      selectedMainTabData,
      selectedSecondaryTabData,
      // Canvas scale
      scaleCanvas,
      notes,
    };

    setHistory((prev) => {
      const newHistory = prev.slice(0, historyStep + 1);
      newHistory.push(currentState);
      return newHistory.slice(-MAX_HISTORY);
    });
    setHistoryStep((prev) => Math.min(prev + 1, MAX_HISTORY - 1));
  }, [
    rectangles,
    getFabricImage,
    getFabric2Image,
    konvaImage1?.src,
    textObjects,
    mainFabricId,
    fabric2Id,
    art1DesignId,
    art2DesignId,
    currentArt1Design,
    currentArt2Design,
    art1Thread,
    art2Thread,
    baseImageUrl,
    fillImageUrl,
    selectedStrap,
    totalTextPrice,
    selectedFabric2Data,
    fabricData, // Add fabricData dependency
    selectedSize, // Add selectedSize dependency
    selectedAddOns, // Add selectedAddOns dependency
    activeMenuTab,
    activeMainTabState,
    activeSecondaryTabState,
    selectedMainTabData,
    selectedSecondaryTabData,
    scaleCanvas,
    historyStep,
    notes,
  ]);
  useEffect(() => {
    if (categoryId && (selectedArt1Option?._id || collectionId)) {
      fetchDesigns({
        categoryId: categoryId,
        collectionId: selectedArt1Option?._id || collectionId,
        setDesignLoading,
        setAllDesign,
        setSearchParam,
      });
    }
  }, [categoryId, selectedArt1Option?._id]);
  const restoreSnapshot = useCallback(async (snapshot) => {
    if (!snapshot) return;

    // Set loading state to prevent UI flicker
    setLoader(true);

    try {
      // Restore rectangles
      setRectangles(snapshot.rectangles);

      // Restore fabric images
      const restoredFabricImages = await Promise.all(
        snapshot.getFabricImage.map((imgData) => {
          return new Promise((resolve) => {
            const image = new Image();
            image.crossOrigin = "Anonymous";
            image.src = imgData.src;
            image.onload = () => {
              resolve({
                image,
                id: imgData.id,
                x: imgData.x,
                y: imgData.y,
                width: imgData.width,
                height: imgData.height,
              });
            };
            image.onerror = () => {
              // Resolve with null if image fails to load
              resolve(null);
            };
          });
        }),
      );
      setFabricImage(restoredFabricImages.filter(Boolean));

      // Restore fabric2 images
      const restoredFabric2Images = await Promise.all(
        snapshot.getFabric2Image.map((imgData) => {
          return new Promise((resolve) => {
            const image = new Image();
            image.crossOrigin = "Anonymous";
            image.src = imgData.src;
            image.onload = () => {
              resolve({
                image,
                id: imgData.id,
                x: imgData.x,
                y: imgData.y,
                width: imgData.width,
                height: imgData.height,
              });
            };
            image.onerror = () => {
              // Resolve with null if image fails to load
              resolve(null);
            };
          });
        }),
      );
      setFabric2Image(restoredFabric2Images.filter(Boolean));

      // Restore konvaImage1
      if (snapshot.konvaImage1Src) {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = snapshot.konvaImage1Src;
        img.onload = () => setKonvaImage1?.(img);
        img.onerror = () => setKonvaImage1?.(null);
      } else {
        setKonvaImage1?.(null);
      }

      // Restore text objects
      if (snapshot.textObjects && Array.isArray(snapshot.textObjects)) {
        setTextObjects(snapshot.textObjects);
      }

      // Restore design states
      setMainFabricId(snapshot.mainFabricId);
      setFabric2Id(snapshot.fabric2Id);
      setArt1DesignId(snapshot.art1DesignId);
      setArt2DesignId(snapshot.art2DesignId);
      setCurrentArt1Design(snapshot.currentArt1Design);
      setCurrentArt2Design(snapshot.currentArt2Design);
      setArt1Thread(snapshot.art1Thread);
      setArt2Thread(snapshot.art2Thread);
      setBaseImageUrl(snapshot.baseImageUrl);
      setFillImageUrl(snapshot.fillImageUrl);
      setSelectedStrap(snapshot.selectedStrap);
      setTotalTextPrice(snapshot.totalTextPrice || 0);
      setSelectedFabric2Data(snapshot.selectedFabric2Data);
      setFabricData(snapshot.fabricData); // Restore main fabric selection state
      setSelectedSize(snapshot.selectedSize); // Restore selected size state
      setSelectedAddOns(snapshot.selectedAddOns || []); // Restore selected add-ons state

      // Restore tab selections
      setActiveMenuTab(snapshot.activeMenuTab || "Main Fabric");
      setActiveMainTabState(snapshot.activeMainTabState || "Velvet");
      setActiveSecondaryTabState(snapshot.activeSecondaryTabState || "Velvet");
      setSelectedMainTabData(snapshot.selectedMainTabData || []);
      setSelectedSecondaryTabData(snapshot.selectedSecondaryTabData || []);

      // Restore canvas scale
      setScaleCanvas(snapshot.scaleCanvas || 1);
      setNotes(snapshot.notes || "");
    } catch (error) {
      console.error("Error restoring snapshot:", error);
    } finally {
      setLoader(false);
    }
  }, []);

  const handleUndo = useCallback(() => {
    if (historyStep > 0) {
      const newStep = historyStep - 1;
      setHistoryStep(newStep);
      restoreSnapshot(history[newStep]);
    }
  }, [historyStep, history, restoreSnapshot]);

  const handleRedo = useCallback(() => {
    if (historyStep < history.length - 1) {
      const newStep = historyStep + 1;
      setHistoryStep(newStep);
      restoreSnapshot(history[newStep]);
    }
  }, [historyStep, history, restoreSnapshot]);

  // Keyboard shortcuts
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "z" && !e.shiftKey) {
        e.preventDefault();
        handleUndo();
      }
      if (
        (e.ctrlKey || e.metaKey) &&
        (e.key === "y" || (e.key === "z" && e.shiftKey))
      ) {
        e.preventDefault();
        handleRedo();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [handleUndo, handleRedo]);

  function deselectAllShapes() {
    setSelectedArt2Id(null);

    Object.keys(textTransformers).forEach((key) => {
      textTransformers[key] = false;
    });
    setTextTransformers({});
  }

  const handleResize = useCallback(() => {
    if (containerCanvasRef.current) {
      const container = containerCanvasRef.current;
      // const containerWidth = container.clientWidth;
      const containerWidth = container.getBoundingClientRect().width;
      // const scaleWidth = containerWidth / dynamicCanvasWidth;
      // const newScale = Math.min(scaleWidth, 1);

      // setScaleCanvas(newScale);
       const scale = Math.min(containerWidth / dynamicCanvasWidth, 1);
      setScaleCanvas(scale);
    }
  // }, [dynamicCanvasWidth, dynamicCanvasHeight]);
  }, [dynamicCanvasWidth]);

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [handleResize]);

  useEffect(() => {
    handleResize();
    if (bgColor && history.length === 0) {
      setTimeout(() => captureSnapshot(), 100);
    }
  }, [bgColor, history.length, captureSnapshot]);

  useEffect(() => {
    if (collectionId) {
      if (collectionId === "all") {
        const allCategory = { _id: "all", title: "All Categories" };
        setCollectionData(allCategory);
        setSelectedArt1Option(allCategory);
        return;
      }

      getCollectionDetail({ collectionId, setLoader, setCollectionData }).then(
        (data) => setSelectedArt1Option(data),
      );

      // Keep non-design selections (fabric, size, personalize, add-ons) unchanged.
      // Reset only design-specific state when switching collection.
      setRectangles((rectangles) =>
        rectangles.filter((rec) => rec.type !== "art1" && rec.type !== "art2"),
      );
      setCurrentArt1Design(null);
      setCurrentArt2Design(null);
      setArt1DesignId(null);
      setArt2DesignId(null);
      setArt1Thread([]);
      setArt2Thread([]);
      setArt2Quantities({});
    }
  }, [collectionId]);

  const handleCollectionDesignChange = useCallback(
    (selectedCollection) => {
      if (!selectedCollection?._id) return;

      const nextCollectionId = selectedCollection._id;
      setSelectedArt1Option(selectedCollection);
      setCollectionId(nextCollectionId);
      setCollectionData(selectedCollection);

      const nextParams = new URLSearchParams(searchParams);
      nextParams.set("collectionId", nextCollectionId);
      setSearchParam(nextParams);
    },
    [searchParams, setSearchParam],
  );

  useEffect(() => {
    if (sizeId) {
      if (
        sizeData &&
        Array.isArray(sizeData) &&
        sizeData.length > 0 &&
        fabricData &&
        Object.keys(fabricData).length > 0
      ) {
        const item = sizeData?.find((io) => io && io._id === sizeId);
        const sizeDetail = fabricData?.size_details?.find(
          (io) => io && io?.size_id === item?._id,
        );
        const price = sizeDetail?.price;
        const accentPrice = sizeDetail?.accent_price || 0;
        setSelectedSize({ ...item, price, accent_price: accentPrice });

        // Update accent fabric price if accent color is selected
        if (fabric2Id && selectedFabric2Data) {
          const accentSizeDetail = selectedFabric2Data.size_details?.find(
            (detail) => detail.size_id === item?._id
          );
          const newAccentPrice = accentSizeDetail?.accent_price || 0;
          setSelectedFabric2Data({
            ...selectedFabric2Data,
            selected_accent_price: newAccentPrice,
          });
        }
      }
    }
  }, [sizeId, sizeData, fabricData]);

  const handleImageProcessing = (baseImage, fillImage) => {
    if (!baseImage || !fillImage || !modifiedCanvasRef.current) return;

    const imgW = baseImage.naturalWidth || baseImage.width;
    const imgH = baseImage.naturalHeight || baseImage.height;
    if (!imgW || !imgH || imgW <= 0 || imgH <= 0) return;

    const targetColor = hexToRgba(HEX_COLOR);

    const originalCanvas = originalCanvasRef.current;
    const modifiedCanvas = modifiedCanvasRef.current;

    originalCanvas.width = Math.round(imgW);
    originalCanvas.height = Math.round(imgH);
    modifiedCanvas.width = Math.round(imgW);
    modifiedCanvas.height = Math.round(imgH);

    const ctx = originalCanvas.getContext("2d");
    ctx.drawImage(baseImage, 0, 0);

    const modifiedCtx = modifiedCanvas.getContext("2d");
    modifiedCtx.drawImage(baseImage, 0, 0);

    const imageData = modifiedCtx.getImageData(
      0,
      0,
      modifiedCanvas.width,
      modifiedCanvas.height,
    );
    const pixels = imageData.data;

    const tolerance = 10;

    const isSimilarColor = (r1, g1, b1, r2, g2, b2, tol) => {
      return (
        Math.abs(r1 - r2) <= tol &&
        Math.abs(g1 - g2) <= tol &&
        Math.abs(b1 - b2) <= tol
      );
    };

    const floodFillWithImage = () => {
      const stack = [];
      const visited = new Set();

      for (let y = 0; y < modifiedCanvas.height; y++) {
        for (let x = 0; x < modifiedCanvas.width; x++) {
          const index = (y * modifiedCanvas.width + x) * 4;
          if (
            isSimilarColor(
              pixels[index],
              pixels[index + 1],
              pixels[index + 2],
              targetColor.r,
              targetColor.g,
              targetColor.b,
              tolerance,
            )
          ) {
            stack.push([x, y]);
          }
        }
      }

      const fillCanvas = document.createElement("canvas");
      const fillImgW = fillImage.naturalWidth || fillImage.width || 1;
      const fillImgH = fillImage.naturalHeight || fillImage.height || 1;
      const aspectRatio = fillImgW / fillImgH;

      const scaledWidth = Math.round(modifiedCanvas.width);
      const scaledHeight = Math.round(scaledWidth / aspectRatio) || 1;
      fillCanvas.width = scaledWidth;
      fillCanvas.height = scaledHeight;

      const fillCtx = fillCanvas.getContext("2d");
      fillCtx.drawImage(fillImage, 0, 0, scaledWidth, scaledHeight);

      const fillData = fillCtx.getImageData(
        0,
        0,
        scaledWidth,
        scaledHeight,
      ).data;

      while (stack.length > 0) {
        const [currentX, currentY] = stack.pop();

        const index = (currentY * modifiedCanvas.width + currentX) * 4;
        if (visited.has(index)) continue;
        visited.add(index);

        const fillX = Math.floor(
          (currentX / modifiedCanvas.width) * scaledWidth,
        );
        const fillY = Math.floor(
          (currentY / modifiedCanvas.height) * scaledHeight,
        );
        const fillIndex = (fillY * scaledWidth + fillX) * 4;

        pixels[index] = fillData[fillIndex];
        pixels[index + 1] = fillData[fillIndex + 1];
        pixels[index + 2] = fillData[fillIndex + 2];
        pixels[index + 3] = fillData[fillIndex + 3];
      }
    };

    floodFillWithImage();

    modifiedCtx.putImageData(imageData, 0, 0);

    const updatedImage = new window.Image();
    updatedImage.crossOrigin = "Anonymous";
    updatedImage.src = modifiedCanvas.toDataURL();
    updatedImage.onload = () => setKonvaImage1?.(updatedImage);
  };

  useEffect(() => {
    const baseImage = new window.Image();
    const fillImage = new window.Image();

    const hasArt1 = rectangles.some((rect) => rect && rect.type === "art1");
    const art1Rect = rectangles?.find((rect) => rect && rect.type === "art1");

    if (
      baseImageUrl &&
      fillImageUrl &&
      hasArt1 &&
      art1Rect &&
      baseImageUrl === art1Rect.src
    ) {
      baseImage.crossOrigin = "anonymous";
      fillImage.crossOrigin = "anonymous";

      let baseImageLoaded = false;
      let fillImageLoaded = false;

      baseImage.src = baseImageUrl;
      fillImage.src = fillImageUrl;

      const checkImagesLoaded = () => {
        if (baseImageLoaded && fillImageLoaded) {
          handleImageProcessing(baseImage, fillImage);
        }
      };

      baseImage.onload = () => {
        baseImageLoaded = true;
        checkImagesLoaded();
      };

      fillImage.onload = () => {
        fillImageLoaded = true;
        checkImagesLoaded();
      };
    } else if (!fillImageUrl && hasArt1 && art1Rect) {
      setKonvaImage1?.(null);
    }
  }, [baseImageUrl, fillImageUrl, rectangles]);

  const convertToBase64 = async (imageUrl) => {
    try {
      setLoader(true);
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const reader = new FileReader();

      return new Promise((resolve, reject) => {
        reader.readAsDataURL(blob);
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
        setLoader(false);
      });
    } catch (error) {
      console.error("Error converting to Base64:", error);
      return null;
    }
  };

  useEffect(() => {
    if (designData) {
      const fetchBase64 = async () => {
        if (designData) {
          if (designData?.konvaImage1 && designData?.design_data?.images) {
            setLoader(true);
            const konvaBase64 = await convertToBase64(
              Constants.imgDomain + designData.konvaImage1,
            );
            designData.design_data.images.konvaImage1 = konvaBase64;
          }
          loadDesign(designData);
          setLoader(false);
        }
      };
      fetchBase64();
      setLoader(false);
    }
  }, [designData]);

  const checkDeselect = (e) => {
    if (e.target === e.target.getStage()) {
      setSelectedArt2Id(null);
      setTextTransformers({});
    }
  };
  const outLineChange = (prop, designType, name) => {
    setDesignImageId(prop.id);
    const { image } = prop;

    rectangles.forEach((rectangle) => {
      if (rectangle.type === designType) {
        const newSrc = `${Constants.imgDomain}${image}`;
        if (rectangle.name === name) {
          rectangle.src = newSrc;
          rectangle.currentSelectedThread = prop;
        }
      }
    });

    setRectangles([...rectangles]);

    // If this is an art1 design and accent color is applied, regenerate konvaImage1
    if (designType === "art1" && fillImageUrl && fabric2Id) {
      const art1Rect = rectangles?.find((rect) => rect && rect.type === "art1");
      if (art1Rect && art1Rect.name === name) {
        // Trigger reprocessing of the image with new thread color
        const baseImage = new window.Image();
        const fillImage = new window.Image();

        baseImage.crossOrigin = "anonymous";
        fillImage.crossOrigin = "anonymous";

        baseImage.src = art1Rect.src;
        fillImage.src = fillImageUrl;

        const checkImagesLoaded = () => {
          if (baseImage.complete && fillImage.complete) {
            handleImageProcessing(baseImage, fillImage);
          }
        };

        if (baseImage.complete && fillImage.complete) {
          handleImageProcessing(baseImage, fillImage);
        } else {
          baseImage.onload = () => {
            if (fillImage.complete) {
              handleImageProcessing(baseImage, fillImage);
            }
          };
          fillImage.onload = () => {
            if (baseImage.complete) {
              handleImageProcessing(baseImage, fillImage);
            }
          };
        }
      }
    }
  };
  const handleAddToCart = async ({ customizedImageId }) => {
    deselectAllShapes();
    await new Promise((resolve) => setTimeout(resolve, 0));

    if (!stageRef.current) {
      setLoader(false);
      toast.warning("Please Customize Product!");
      throw new Error("Please Customize Product!");
    }

    stageRef.current.find("Transformer").forEach((t) => t.nodes([]));
    stageRef.current.batchDraw();

    setLoader(true);
    const dataURL = stageRef.current.toDataURL();
    const blob = await (await fetch(dataURL)).blob();
    const formData = new FormData();

    formData.append("main_fabric_id", mainFabricId);
    formData.append("customize_image_id", customizedImageId);
    formData.append("name", `custom-${categoryData.title}-${getUniqueId()}`);
    formData.append("category", categoryId);
    formData.append(
      "sub_category",
      collectionId == "all" ? art1Thread?.collectionId?.[0] : collectionId,
    );
    formData.append(
      "description",
      product?.description ? product?.description : "This is a custom product",
    );
    formData.append("images", blob, `customizedImg-${Date.now()}.png`);
    formData.append("quantity", 1);
    formData.append("notes", notes);

    formData.append("price", totalPrice);
    formData.append("offer_price", totalPrice);
    formData.append("status", "active");
    const matchingBagPrice = JSON.stringify({
      name: selectedMatchingSize.name,
      price: selectedMatchingSize.price,
    });
    formData.append("matching_bag", matchingBagPrice);
    formData.append(
      "price_data",
      JSON.stringify({
        fabric_price: selectedSize?.price || 0,
        art1_design_price: currentArt1Design?.price || 0,
        art2_design_price: calculateArt2TotalPrice() || 0,
        accent_price: (fabric2Id && selectedFabric2Data?.selected_accent_price) ? selectedFabric2Data.selected_accent_price : 0,
        matching_bag: matchingBagPrice || 0,
        text_price: totalTextPrice || 0,
        add_ons_price: totalAddOnPrice || 0,
        total_price: totalPrice || 0,
      }),
    );

    if (selectedStrap) {
      if (selectedStrap.name !== "No Strap") {
        formData.append("strap", JSON.stringify(selectedStrap));
      }
    }
    if (
      selectedSize._id &&
      selectedSize._id !== "undefined" &&
      selectedSize._id !== "null"
    ) {
      formData.append("size_id", selectedSize._id);
    }
    formData.append("text_objects", JSON.stringify(textObjects));
    await addToCart({ formData, setLoader, dispatch });
    setRefetchProducts((p) => !p);
  };

  const generateDesignOnlyImage = async () => {
    // Create a temporary stage for design-only rendering
    const tempStage = new window.Konva.Stage({
      container: document.createElement('div'),
      width: dynamicCanvasWidth,
      height: dynamicCanvasHeight,
    });

    const tempLayer = new window.Konva.Layer();
    tempStage.add(tempLayer);

    // Add Art1 designs (without accent color)
    const hasArt1 = rectangles.some((r) => r && r.type === "art1");
    if (hasArt1) {
      for (const rect of rectangles.filter((r) => r && r.type === "art1")) {
        const img = new window.Image();
        img.crossOrigin = "Anonymous";
        await new Promise((resolve) => {
          img.onload = resolve;
          img.src = rect.src;
        });

        const konvaImg = new window.Konva.Image({
          image: img,
          x: rect.x,
          y: rect.y,
          width: rect.width || 100,
          height: rect.height || 100,
        });
        tempLayer.add(konvaImg);
      }
    }

    // Add Art2 designs
    const hasArt2 = rectangles.some((r) => r && r.type === "art2");
    if (hasArt2) {
      for (const rect of rectangles.filter((r) => r && r.type === "art2")) {
        const img = new window.Image();
        img.crossOrigin = "Anonymous";
        await new Promise((resolve) => {
          img.onload = resolve;
          img.src = rect.src;
        });

        const konvaImg = new window.Konva.Image({
          image: img,
          x: rect.x,
          y: rect.y,
          width: rect.width || 100,
          height: rect.height || 100,
        });
        tempLayer.add(konvaImg);
      }
    }

    // Add text objects
    if (textObjects && textObjects.length > 0) {
      for (const textObj of textObjects) {
        if (!textObj?.text) continue;

        const alignment = textObj.textAlign || "center";
        let initialX = textObj.position?.x;
        if (!initialX) {
          switch (alignment) {
            case "left":
              initialX = 10;
              break;
            case "right":
              initialX = dynamicCanvasWidth - 10;
              break;
            case "center":
            default:
              initialX = dynamicCanvasWidth / 2;
              break;
          }
        }

        if (textObj.shape === "straight") {
          const text = new window.Konva.Text({
            x: 5,
            y: textObj.position?.y || dynamicCanvasHeight / 2,
            text: formatMixedHebrewText(textObj.text, textObj.textAlign) || "",
            fontSize: calculateFontSize(
              textObj.text?.length || 0,
              textObj.fontSize || 48,
            ),
            fontFamily: textObj?.fontFamily || "Baziporen, sans-serif",
            fill: textObj?.color || "#FFD700",
            align: alignment,
            verticalAlign: "middle",
            scaleX: textObj?.scale?.x || 1,
            scaleY: textObj?.scale?.y || 1,
            rotation: textObj?.rotation || 0,
            width: dynamicCanvasWidth * 0.95,
            wrap: "word",
            lineHeight: textObj?.lineHeight || 1.1,
            letterSpacing: Math.max(1, textObj?.letterSpacing || 0),
            padding: textObj?.padding || 10,
          });
          tempLayer.add(text);
        } else {
          // For curved text (TextPath)
          const path = textObj.shape === "arch"
            ? "M 20,150 A 100,100 0 0,1 250,150"
            : `M 0,${-(textObj.radius || 80) * 4} A ${(textObj.radius || 80) * 4
            },${(textObj.radius || 80) * 4} 0 1,0 0,${(textObj.radius || 80) * 4
            } A ${(textObj.radius || 80) * 4},${(textObj.radius || 80) * 4
            } 0 1,0 0,${-(textObj.radius || 80) * 4}`;

          const textPath = new window.Konva.TextPath({
            x: 5,
            y: textObj.position?.y || dynamicCanvasHeight / 2,
            data: path,
            text: formatMixedHebrewText(textObj.text, textObj.textAlign) || "",
            fontSize: calculateFontSize(
              textObj.text?.length || 0,
              textObj.fontSize || 48,
            ),
            fontFamily: textObj?.fontFamily || "Baziporen, sans-serif",
            fill: textObj?.color || "#FFD700",
            align: alignment,
            scaleX: textObj?.scale?.x || 1,
            scaleY: textObj?.scale?.y || 1,
            rotation: textObj?.rotation || 0,
            letterSpacing: textObj?.letterSpacing || 0,
          });
          tempLayer.add(textPath);
        }
      }
    }

    tempLayer.batchDraw();

    // Export as high-resolution image
    const designOnlyDataURL = tempStage.toDataURL({
      mimeType: "image/png",
      quality: 1.0,
      // pixelRatio: 3, // Higher resolution for design-only image
      pixelRatio: 2, // Adjust as needed for quality/performance balance
    });

    // Clean up
    tempStage.destroy();

    return designOnlyDataURL;
  };

  const handleExportImage = async (type) => {
    // Hide delete buttons during save
    setHideDeleteButtons(true);
    setIsComparedButtonEnabled(true);
    deselectAllShapes();

    setTimeout(async () => {
      try {
        if (stageRef.current) {
          stageRef.current.find("Transformer").forEach((t) => t.nodes([]));
          stageRef.current.batchDraw();
          setLoader(true);

          
          // Store current scale and reset to 1 for high-quality export
          const currentScaleX = stageRef.current.scaleX();
          const currentScaleY = stageRef.current.scaleY();
          stageRef.current.scaleX(1);
          stageRef.current.scaleY(1);
          stageRef.current.batchDraw();

          // Generate complete product image
          const dataURL = stageRef.current.toDataURL({
            mimeType: "image/png",
            quality: 1.0,
            pixelRatio: 2,
          });

          // Restore scale after export
          stageRef.current.scaleX(currentScaleX);
          stageRef.current.scaleY(currentScaleY);
          stageRef.current.batchDraw();

          const blob = await (await fetch(dataURL)).blob();

          // Generate design-only image (without main fabric and accent color)
          const designOnlyDataURL = await generateDesignOnlyImage();
          if (!designOnlyDataURL) {
            throw new Error("Design-only image generation failed.");
          }

          const designOnlyBlob = await (await fetch(designOnlyDataURL)).blob();
          if (type === "cart" && (!designOnlyBlob || designOnlyBlob.size === 0)) {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.error("Design-only image is required to add this product to cart.");
            setLoader(false);
            setHideDeleteButtons(false);
            return;
          }

          const formData = new FormData();
          formData.append("file", blob, `customizedImg-${Date.now()}.png`);
          formData.append("design_only_image", designOnlyBlob, `designOnly-${Date.now()}.png`);
          if (type === "cart") {
            formData.append("cart_action", "yes");
          }

          formData.append("main_fabric_id", mainFabricId);
          formData.append("accent_color_id", fabric2Id);

          formData.append("letter_count", letterCount);
          formData.append("notes", notes);

          if (productId) {
            formData.append("product_id", productId);
          }

          const matchingBagPrice = JSON.stringify({
            name: selectedMatchingSize.name,
            price: selectedMatchingSize.price,
          });
          formData.append("matching_bag", matchingBagPrice);
          formData.append("price", totalPrice);

          formData.append(
            "price_data",
            JSON.stringify({
              fabric_price: selectedSize?.price || 0,
              art1_design_price: currentArt1Design?.price || 0,
              art2_design_price: calculateArt2TotalPrice() || 0,
              accent_price: (fabric2Id && selectedFabric2Data?.selected_accent_price) ? selectedFabric2Data.selected_accent_price : 0,
              matching_bag: matchingBagPrice || 0,
              text_price: totalTextPrice || 0,
              add_ons_price: totalAddOnPrice || 0,
              total_price: totalPrice || 0,
            }),
          );

          if (
            selectedSize._id &&
            selectedSize._id !== "undefined" &&
            selectedSize._id !== "null"
          ) {
            formData.append("size_id", selectedSize._id);
          }

          if (!designImageId) {
            if (currentArt1Design) {
              const art1Data = currentArt1Design.images?.find(
                (image) => image && image.is_main === 1,
              );
              if (art1Data) {
                formData.append("art1_design_image_id", art1Data.id);
              }
            }

            if (currentArt2Design) {
              const art2Data = currentArt2Design.images?.find(
                (image) => image && image.is_main === 1,
              );
              if (art2Data) {
                formData.append("art2_design_image_id", art2Data.id);
              }
            }
          } else if (designImageId) {
            formData.append("design_image_id", designImageId);
          }

          const designData = await saveDesign();

          if (designData) {
            formData.append("design_data", JSON.stringify(designData));
          }

          if (designData?.images?.konvaImage1) {
            formData.append(
              "konvaImage1",
              designData.images.konvaImage1,
              `konvaImage1-${Date.now()}.png`,
            );
          }

          // Add text objects to form data
          formData.append("text_objects", JSON.stringify(textObjects));

          const response = await axios.post(
            Constants.postUrls.uploadCustomizedImage,
            formData,
            {
              headers: {
                Authorization: localStorage.getItem("token"),
              },
            },
          );

          const uploadedCustomizedImageId = response?.data?.data?._id;
          if (response.status !== 200 || !uploadedCustomizedImageId) {
            throw new Error(response?.data?.message || "Failed to save customized image.");
          }

          if (type === "cart") {
            try {
              await handleAddToCart({
                customizedImageId: uploadedCustomizedImageId,
              });
            } catch (error) {
              try {
                await axios.delete(
                  `${Constants.deleteUrls.removeCustomizedImage}/${uploadedCustomizedImageId}`,
                  {
                    headers: {
                      Authorization: localStorage.getItem("token"),
                    },
                  },
                );
              } catch (cleanupError) {
                console.error("Failed to clean up customized image:", cleanupError);
              }
              throw error;
            }
          } else {
            toast.clearWaitingQueue();
            toast.dismiss();
            toast.success("Image added successfully!", {
              style: { backgroundColor: "green", color: "white" },
            });
          }

          setLoader(false);
          // Show delete buttons again after save is complete
          setHideDeleteButtons(false);
        } else {
          toast.warning("Please Customize Product!");
          setLoader(false);
          // Show delete buttons again
          setHideDeleteButtons(false);
        }
      } catch (error) {
        toast.clearWaitingQueue();
        toast.dismiss();
        toast.error(error?.response?.data?.message || error.message);
        const { status, message } = error?.response?.data || {};
        if (status === 401 && message === "Unauthorized!") {
          localStorage.removeItem("token");
          setLoginModalIsOpen(true);
        }
        setLoader(false);
        // Show delete buttons again on error
        setHideDeleteButtons(false);
      }
    }, 0);
  };

  const saveDesign = async () => {
    const konvaImage1Blob = konvaImage1?.src
      ? await (await fetch(konvaImage1.src)).blob()
      : null;

    const designData = {
      rectangles: rectangles.map((rect) => ({
        id: rect.id,
        x: rect.x,
        y: rect.y,
        src: rect.src,
        width: rect.width,
        height: rect.height,
        type: rect.type,
      })),
      images: {
        konvaImage1: konvaImage1Blob,
        fabricImages: getFabricImage.map((img) => ({
          src: img.image.src,
          position: { x: img.x, y: img.y },
          size: { width: img.width, height: img.height },
        })),
        getFabric2Image: getFabric2Image.map((img) => ({
          src: img.image.src,
          position: { x: img.x, y: img.y },
          size: { width: img.width, height: img.height },
        })),
      },
      textObjects: textObjects,
      mainFabricId: mainFabricId,
      fabric2Id: fabric2Id, // Add fabric2Id to saved data
      art1DesignId: art1DesignId,
      art2DesignId: art2DesignId,
      currentArt1Design: currentArt1Design,
      currentArt2Design: currentArt2Design,
      art1Thread: art1Thread,
      art2Thread: art2Thread,
      baseImageUrl: baseImageUrl,
      fillImageUrl: fillImageUrl,
      selectedStrap: selectedStrap,
      totalTextPrice: totalTextPrice,
      addOns: selectedAddOns,
      fabric2Data: selectedFabric2Data,
      notes: notes,
    };
    localStorage.setItem("savedDesign", JSON.stringify(designData));
    return designData;
  };
  const loadDesign = async (designData) => {
    const savedData = designData?.design_data || null;
    if (savedData) {
      console.log("Loading design data:", designData);
      
      // Load fabric images
      const fabricImages = savedData.images?.fabricImages || [];
      const getFabric2Image = savedData.images?.getFabric2Image || [];

      const loadedImages = await Promise.all(
        fabricImages.map((imgData) => {
          return new Promise((resolve) => {
            const image = new Image();
            image.src = imgData.src;
            image.crossOrigin = "Anonymous";
            image.onload = () => {
              resolve({
                image: image,
                x: imgData.position.x,
                y: imgData.position.y,
                width: imgData.size.width,
                height: imgData.size.height,
              });
            };
            image.onerror = () => {
              resolve({
                image: null,
                x: imgData.position.x,
                y: imgData.position.y,
                width: imgData.size.width,
                height: imgData.size.height,
              });
            };
          });
        }),
      );

      const loadedFabric2Images = await Promise.all(
        getFabric2Image.map((imgData) => {
          return new Promise((resolve) => {
            const image = new Image();
            image.src = imgData.src;
            image.crossOrigin = "Anonymous";
            image.onload = () => {
              resolve({
                image: image,
                x: imgData.position.x,
                y: imgData.position.y,
                width: imgData.size.width,
                height: imgData.size.height,
              });
            };
            image.onerror = () => {
              resolve({
                image: null,
                x: imgData.position.x,
                y: imgData.position.y,
                width: imgData.size.width,
                height: imgData.size.height,
              });
            };
          });
        }),
      );

      // Update state - Main Fabric and Accent Fabric (load both in parallel)
      const mainFabricIdToSet = savedData.mainFabricId;
      const accentColorId = designData.accent_color_id || savedData.fabric2Id;
      
      // Load both fabrics in parallel
      const fabricPromises = [];
      
      if (mainFabricIdToSet) {
        fabricPromises.push(
          axios.get(
            `${Constants.getUrls.getSingleFabric}/${mainFabricIdToSet}`,
            {
              headers: {
                Authorization: localStorage.getItem("token"),
              },
            }
          ).then(({ data }) => ({ type: 'main', data }))
          .catch(err => {
            console.error("Error loading main fabric:", err);
            return { type: 'main', error: err };
          })
        );
      }
      
      if (accentColorId) {
        fabricPromises.push(
          axios.get(
            `${Constants.getUrls.getSingleFabric}/${accentColorId}`,
            {
              headers: {
                Authorization: localStorage.getItem("token"),
              },
            }
          ).then(({ data }) => ({ type: 'accent', data }))
          .catch(err => {
            console.error("Error loading accent fabric:", err);
            return { type: 'accent', error: err };
          })
        );
      }
      
      // Wait for all fabric data to load
      if (fabricPromises.length > 0) {
        const fabricResults = await Promise.all(fabricPromises);
        
        fabricResults.forEach(result => {
          if (result.error) return;
          
          if (result.type === 'main' && result.data?.status === "success" && result.data?.data) {
            const fabricInfo = result.data.data;
            console.log("Loaded main fabric info:", fabricInfo);
            setFabricData(fabricInfo);
            setMainFabricId(mainFabricIdToSet);
            
            // Set the active tab based on fabric type
            if (fabricInfo.fabric_type?.name) {
              console.log("Setting main fabric tab to:", fabricInfo.fabric_type.name);
              setActiveMainTabState(fabricInfo.fabric_type.name);
              
              // Update selected tab data to include this fabric
              if (mainFabricList && mainFabricList[fabricInfo.fabric_type.name]) {
                setSelectedMainTabData(mainFabricList[fabricInfo.fabric_type.name]);
              }
            }
          }
          
          if (result.type === 'accent' && result.data?.status === "success" && result.data?.data) {
            const accentFabricInfo = result.data.data;
            console.log("Loaded accent fabric info:", accentFabricInfo);
            setFabric2Id(accentColorId);
            setSelectedFabric2Data(accentFabricInfo);
            
            // Set the active secondary tab based on fabric type
            if (accentFabricInfo.fabric_type?.name) {
              console.log("Setting secondary fabric tab to:", accentFabricInfo.fabric_type.name);
              setActiveSecondaryTabState(accentFabricInfo.fabric_type.name);
              
              // Update selected tab data to include this fabric
              if (mainFabricList && mainFabricList[accentFabricInfo.fabric_type.name]) {
                setSelectedSecondaryTabData(mainFabricList[accentFabricInfo.fabric_type.name]);
              }
            }
          }
        });
      }
      
      // Fallback: set IDs even if fetch fails
      if (mainFabricIdToSet && !fabricData) {
        setMainFabricId(mainFabricIdToSet);
      }
      if (accentColorId && !fabric2Id) {
        setFabric2Id(accentColorId);
      }
      
      setBgColor("white");

      setRectangles(savedData.rectangles || []);
      setFabricImage(loadedImages);
      setFabric2Image(loadedFabric2Images);

      // Load text objects if they exist
      if (savedData.textObjects && Array.isArray(savedData.textObjects)) {
        setTextObjects(savedData.textObjects);
      } else if (
        savedData.transforms &&
        savedData.transforms.selectedTextImage
      ) {
        // Handle text from transforms object (new format from API)
        const textTransform = savedData.transforms.selectedTextImage;
        const textObject = createDefaultTextObject();

        textObject.text = textTransform.text || savedData.textInput || "";
        textObject.position = {
          x: textTransform.x || dynamicCanvasWidth / 2,
          y: textTransform.y || dynamicCanvasHeight / 2,
        };
        textObject.fontSize =
          textTransform.fontSize || savedData.fontSize || 48;
        textObject.fontFamily =
          textTransform.fontFamily ||
          savedData.fontFamily ||
          "Baziporen, sans-serif";
        textObject.color = textTransform.fill || savedData.color || "#cc9933";
        textObject.scale = {
          x: textTransform.scaleX || savedData.textTransform?.x || 1,
          y: textTransform.scaleY || savedData.textTransform?.y || 1,
        };
        textObject.rotation = textTransform.rotation || 0;
        textObject.shape = savedData.shape || "straight";
        textObject.letterSpacing =
          textTransform.letterSpacing || savedData.letterSpacing || 0;
        textObject.lineHeight =
          textTransform.lineHeight || savedData.lineHeight || 1.2;
        textObject.radius = savedData.radius || 94;

        setTextObjects([textObject]);
      } else {
        // Fallback for old designs
        const oldTextObject = createDefaultTextObject();
        if (savedData.textInput) {
          oldTextObject.text = savedData.textInput.replace(
            /<br\s*\/?>/gi,
            "\n",
          );
          oldTextObject.fontFamily =
            savedData.fontFamily || "Baziporen, sans-serif";
          oldTextObject.fontSize = savedData.fontSize || 48;
          oldTextObject.color = savedData.color || "#cc9933";
          oldTextObject.shape = savedData.shape || "straight";
          oldTextObject.letterSpacing = savedData.letterSpacing || 0;
          oldTextObject.lineHeight = savedData.lineHeight || 1.2;
          oldTextObject.position = savedData.textPosition || {
            x: dynamicCanvasWidth / 2,
            y: dynamicCanvasHeight / 2,
          };
          oldTextObject.scale = savedData.textTransform || { x: 1, y: 1 };
          oldTextObject.radius = savedData.radius || 94;
        }
        setTextObjects([oldTextObject]);
      }

      // Load Art1 Design
      const art1DesignIdToSet = savedData.designId?.[0] || savedData.art1DesignId;
      if (art1DesignIdToSet) {
        setArt1DesignId(art1DesignIdToSet);
      }
      
      // Load Art2 Design and quantities
      const art2DesignIdToSet = savedData.designId?.[1] || savedData.art2DesignId;
      if (art2DesignIdToSet) {
        if (Array.isArray(art2DesignIdToSet)) {
          setArt2DesignId(art2DesignIdToSet);
          // Set quantities for multiple art2 designs
          const quantities = {};
          art2DesignIdToSet.forEach(id => {
            quantities[id] = 1; // Default quantity
          });
          setArt2Quantities(quantities);
        } else {
          setArt2DesignId(art2DesignIdToSet);
          setArt2Quantities({ [art2DesignIdToSet]: 1 });
        }
      }
      
      // Load current designs
      const currentArt1 = savedData.currentDesign || savedData.currentArt1Design || null;
      if (currentArt1) {
        setCurrentArt1Design(currentArt1);
      }
      
      const currentArt2 = savedData.currentDesign || savedData.currentArt2Design || null;
      if (currentArt2) {
        if (Array.isArray(currentArt2)) {
          setCurrentArt2Design(currentArt2);
        } else {
          setCurrentArt2Design([currentArt2]);
        }
      }
      
      // Load thread colors
      const art1ThreadData = savedData.art1Thread || savedData.currentArt1Design || savedData.currentDesign;
      if (art1ThreadData) {
        setArt1Thread(art1ThreadData);
      }
      
      const art2ThreadData = savedData.art2Thread || savedData.currentArt2Design || savedData.currentDesign;
      if (art2ThreadData) {
        if (Array.isArray(art2ThreadData)) {
          setArt2Thread(art2ThreadData);
        } else {
          setArt2Thread([art2ThreadData]);
        }
      }

      setBaseImageUrl(savedData.baseImageUrl);
      setFillImageUrl(savedData.fillImageUrl);
      setSelectedStrap(savedData?.strap || savedData?.selectedStrap || strapArr[0]);
      setTotalTextPrice(savedData.totalTextPrice || 0);
      setNotes(savedData.notes || "");

      // Load size selection
      const sizeIdToSet = designData.size_id || null;
      if (sizeIdToSet) {
        setSizeId(sizeIdToSet);
      }

      // Load matching bag selection
      const matchingBg = designData?.matching_bag || null;
      if (matchingBg) {
        try {
          const parseMaBag = typeof matchingBg === 'string' ? JSON.parse(matchingBg) : matchingBg;
          const matchingSize = matchingData?.find((io) => io && io.name === parseMaBag.name);
          if (matchingSize) {
            setSelectedMatchingSize(matchingSize);
          }
        } catch (err) {
          console.error("Error parsing matching bag:", err);
        }
      }

      // Load add-ons selection
      if (savedData.addOns && Array.isArray(savedData.addOns)) {
        setSelectedAddOns(savedData.addOns);
        // Calculate total add-ons price
        const addOnsPrice = savedData.addOns.reduce((total, addon) => {
          return total + (addon.price || 0) * (addon.quantity || 1);
        }, 0);
        setTotalAddOnPrice(addOnsPrice);
      }

      // Load konvaImage1
      if (savedData.images.konvaImage1) {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = savedData.images.konvaImage1;
        img.onload = () => setKonvaImage1?.(img);
      }
      
      // Capture initial snapshot after loading
      setTimeout(() => {
        captureSnapshot();
      }, 500);
    }
  };
  useEffect(() => {
    const isEditParam = searchParams.get("isEdit");
    setProductId(searchParams.get("productId") || null);
    setIsEditable(isEditParam === "true" || isEditParam === "1");
    setCustomizeImageId(searchParams.get("customizeImageId") || null);
    setCategoryId(searchParams.get("categoryId"));
    setCollectionId(searchParams.get("collectionId") || "all");
  }, [searchParams]);

  useEffect(() => {
    if (productId) {
      getSingleProduct({ id: productId, setLoader, setCartBtnMsg, setProduct });
    }
  }, [productId]);

  useEffect(() => {
    if (
      customizeImageId &&
      customizeImageId !== "null" &&
      customizeImageId !== "undefined"
    ) {
      getCustomization({ customizeImageId, setLoader, setDesignData });
    }
  }, [customizeImageId]);

  // Fetch full fabric data when mainFabricId changes
  useEffect(() => {
    if (mainFabricId) {
      getFabricData({
        mainFabricId,
        setLoader,
        setFabricData,
      });
    }
  }, [mainFabricId]);

  // Update tab data when mainFabricList is loaded and fabric is selected
  useEffect(() => {
    if (mainFabricList && Object.keys(mainFabricList).length > 0 && fabricData && fabricData.fabric_type?.name) {
      console.log("Updating main tab data for fabric type:", fabricData.fabric_type.name);
      setActiveMainTabState(fabricData.fabric_type.name);
      if (mainFabricList[fabricData.fabric_type.name]) {
        setSelectedMainTabData(mainFabricList[fabricData.fabric_type.name]);
      }
    }
  }, [mainFabricList, fabricData]);

  // Update secondary tab data when accent fabric is selected
  useEffect(() => {
    if (mainFabricList && Object.keys(mainFabricList).length > 0 && selectedFabric2Data && selectedFabric2Data.fabric_type?.name) {
      console.log("Updating secondary tab data for fabric type:", selectedFabric2Data.fabric_type.name);
      setActiveSecondaryTabState(selectedFabric2Data.fabric_type.name);
      if (mainFabricList[selectedFabric2Data.fabric_type.name]) {
        setSelectedSecondaryTabData(mainFabricList[selectedFabric2Data.fabric_type.name]);
      }
    }
  }, [mainFabricList, selectedFabric2Data]);

  useEffect(() => {
    if (fabricData) {
      if (fabricData?.fabric_type?.size_details) {
        const sizeIds = fabricData?.fabric_type?.size_details.map((io) => io.size_id);
        if (Array.isArray(sizeIds) && sizeIds.length > 0) {
          handleSizeData({
            sizeIds,
            setLoader,
            setSizeData,
            setSelectedSize,
            fabricData,
            categoryId,
          });
        } else {
          setSizeData([]);
          setSelectedSize({});
        }
      }
    }
  }, [fabricData]);

  // Calculate ART 2 total price based on quantities
  const calculateArt2TotalPrice = useCallback(() => {
    if (!getAllDesign || !art2Quantities) return 0;

    const art2Data = getAllDesign.find((item) => item && item.design_type === "art2");
    if (!art2Data) return 0;

    return Object.entries(art2Quantities).reduce((total, [designId, quantity]) => {
      const design = art2Data.fabrics.find((d) => d._id === designId);
      if (design && quantity > 0) {
        return total + (design.price || 0) * quantity;
      }
      return total;
    }, 0);
  }, [getAllDesign, art2Quantities]);

  useEffect(() => {
    const art2TotalPrice = calculateArt2TotalPrice();
    // Use accent fabric's accent_price if accent color is selected
    const accentPrice = fabric2Id && selectedFabric2Data?.selected_accent_price
      ? selectedFabric2Data.selected_accent_price
      : 0;

    setTotalPrice(
      (Number(selectedSize?.price) || 0) +
      (Number(currentArt1Design?.price) || 0) +
      art2TotalPrice +
      (Number(totalTextPrice) || 0) +
      (Number(selectedMatchingSize?.price) || 0) +
      (Number(totalAddOnPrice) || 0) +
      (Number(accentPrice) || 0), // Add accent fabric's accent_price when accent color is selected
    );
  }, [
    selectedSize,
    currentArt1Design,
    art2Quantities, // Use art2Quantities instead of currentArt2Design
    totalTextPrice,
    selectedMatchingSize,
    totalAddOnPrice,
    calculateArt2TotalPrice,
    fabric2Id, // Add fabric2Id to dependencies to recalculate when accent color changes
    selectedFabric2Data, // Add selectedFabric2Data to recalculate when accent fabric data changes
  ]);

  // Handle text object selection
  const handleTextSelect = (textId) => {
    setTextTransformers((prev) => {
      const newState = {};
      Object.keys(prev).forEach((key) => {
        newState[key] = false;
      });
      newState[textId] = true;
      return newState;
    });
  };

  // Handle text object drag end
  const handleTextDragEnd = (textId, e) => {
    const node = e.target;
    const newTextObjects = textObjects
      .map((textObj) => {
        if (textObj.id === textId) {
          return {
            ...textObj,
            position: { x: node.x(), y: node.y() },
          };
        }
        return textObj;
      })
      .filter(Boolean);
    setTextObjects(newTextObjects);
    setTimeout(() => captureSnapshot(), 100);
  };

  // Handle text object transform end
  const handleTextTransformEnd = (textId, e) => {
    const node = e.target;
    const newTextObjects = textObjects
      .map((textObj) => {
        if (textObj.id === textId) {
          return {
            ...textObj,
            scale: { x: node.scaleX(), y: node.scaleY() },
            rotation: node.rotation(),
          };
        }
        return textObj;
      })
      .filter(Boolean);
    setTextObjects(newTextObjects);
    setTimeout(() => captureSnapshot(), 100);
  };

  // Update total letter count and price
  const setTotalLetterCount = (count) => {
    setLetterCount(count);
  };

  // Tab content rendering function
  const renderTabContent = (isMobile = false) => {
    const containerClass = isMobile
      ? "d-lg-none d-block"
      : "d-none d-lg-block";
    const wrapperClass = isMobile ? "" : "col-12 col-lg-6 px-3";

    const content = {
      "Main Fabric": (
        <MainFabric
          setMainFabricId={setMainFabricId}
          setBgColor={setBgColor}
          setFabricImage={setFabricImage}
          selectedFabricImage={getFabricImage}
          canvasWidth={dynamicCanvasWidth}
          canvasHeight={dynamicCanvasHeight}
          fabricData={fabricData}
          setFabricData={setFabricData}
          selectedSize={selectedSize}
          mainFabricList={mainFabricList}
          activeTabState={activeMainTabState}
          setActiveTabState={setActiveMainTabState}
          setSelectedTabData={setSelectedMainTabData}
          selectedTabData={selectedMainTabData}
          onFabricSelect={() => {
            setTimeout(() => captureSnapshot(), 100);
          }}
          snapshotData={history[historyStep] || null}
          captureSnapshot={captureSnapshot}
        />
      ),
      "Accent Color": (
        <Fabric2
          setFabric2Id={setFabric2Id}
          fabric2Id={fabric2Id}
          mainFabricId={mainFabricId}
          setFabric2Image={setFabric2Image}
          setRectangles={setRectangles}
          rectangles={rectangles}
          setSelectedFabric2Data={setSelectedFabric2Data}
          setBaseImageUrl={setBaseImageUrl}
          setKonvaImage1={setKonvaImage1}
          setFillImageUrl={setFillImageUrl}
          mainFabricList={mainFabricList}
          activeTabState={activeSecondaryTabState}
          setActiveTabState={setActiveSecondaryTabState}
          setSelectedTabData={setSelectedSecondaryTabData}
          selectedTabData={selectedSecondaryTabData}
          selectedSize={selectedSize}
          onFabricSelect={() => {
            setTimeout(() => captureSnapshot(), 100);
          }}
        />
      ),
      Personalize: (
        <Personalize
          textObjects={textObjects}
          setTextObjects={setTextObjects}
          setTotalLetterCount={setTotalLetterCount}
          setTotalTextPrice={setTotalTextPrice}
          canvasHeight={dynamicCanvasHeight}
          canvasWidth={dynamicCanvasWidth}
          captureSnapshot={captureSnapshot}
          handleUndo={handleUndo}
          historyStep={historyStep}
          handleRedo={handleRedo}
          history={history}
          colorList={colorList}
        />
      ),
      Design: (
        <Design
          mainFabricId={mainFabricId}
          setRectangles={setRectangles}
          setArt1Thread={setArt1Thread}
          setArt2Thread={setArt2Thread}
          setCurrentArt1Design={setCurrentArt1Design}
          setCurrentArt2Design={setCurrentArt2Design}
          currentArt1Design={currentArt1Design}
          currentArt2Design={currentArt2Design}
          setArt1DesignId={setArt1DesignId}
          setArt2DesignId={setArt2DesignId}
          collectionList={collectionList}
          onDesignSelect={() => {
            setTimeout(() => captureSnapshot(), 100);
          }}
          setBaseImageUrl={setBaseImageUrl}
          selectedArt1Option={selectedArt1Option}
          setSelectedArt1Option={setSelectedArt1Option}
          onCollectionDesignChange={handleCollectionDesignChange}
          loading={designsLoading}
          getAllDesign={getAllDesign}
          art2Quantities={art2Quantities}
          setArt2Quantities={setArt2Quantities}
          dynamicCanvasWidth={dynamicCanvasWidth}
          dynamicCanvasHeight={dynamicCanvasHeight}
        />
      ),
      "Thread Color": (
        <ThreadColorTabContent
          art1Thread={art1Thread}
          art2Thread={art2Thread}
          outLineChange={outLineChange}
          captureSnapshot={captureSnapshot}
        />
      ),
      Size: (
        <SizeTabContent
          sizeData={sizeData}
          selectedSize={selectedSize}
          setSelectedSize={setSelectedSize}
          fabricData={fabricData}
          captureSnapshot={captureSnapshot}
          selectedFabric2Data={selectedFabric2Data}
          setSelectedFabric2Data={setSelectedFabric2Data}
          fabric2Id={fabric2Id}
        />
      ),
      "Add On": (
        <AddOnTabContent
          selectedAddOns={selectedAddOns}
          setSelectedAddOns={setSelectedAddOns}
          setTotalAddOnPrice={setTotalAddOnPrice}
          addOns={addOns}
          captureSnapshot={captureSnapshot}
        />
      ),
    };

    return (
      <div className={`${wrapperClass} ${containerClass}`}>
        {content[activeMenuTab]}
      </div>
    );
  };
  // Render canvas content
  const renderCanvasContent = () => {
    const hasArt1 = rectangles.some((r) => r && r.type === "art1");
    const hasArt2 = rectangles.some((r) => r && r.type === "art2");
    const hasFabric2 = fillImageUrl && fabric2Id;

    return (
      <Layer>
        {/* 1️⃣ Main Fabric Background */}
        {
          // Show selected fabric images
          getFabricImage.map(
            (img, index) =>
              img &&
              img.image && (
                <React.Fragment key={img.id || `fabric-img-${index}`}>
                  <KonvaImage
                    image={img.image}
                    x={img.x || 0}
                    y={img.y || 0}
                    draggable={false}
                    width={img.width || dynamicCanvasWidth}
                    height={img.height || dynamicCanvasHeight}
                  />
                </React.Fragment>
              ),
          )
        }

        {/* 2️⃣ Check if konvaImage1 exists and corresponds to Art1 with Fabric2 */}
        {(() => {
          // Show konvaImage1 only if it's Art1 with Fabric2 applied
          if (konvaImage1 && hasArt1 && hasFabric2) {
            return (
              <>
                {/* Art1 with Fabric2 flood fill */}
                <KonvaImage
                  image={konvaImage1}
                  x={0}
                  y={0}
                  width={dynamicCanvasWidth}
                  height={dynamicCanvasHeight}
                />

                {/* Art2 on top (if exists) */}
                {hasArt2 &&
                  rectangles
                    .filter((rect) => rect && rect.type === "art2")
                    .map((rect, index) => (
                      <Rectangle
                        key={rect.id || `art2-${index}`}
                        backgroundColor={"red"}
                        setBaseImageUrl={setBaseImageUrl}
                        isSelected={selectedArt2Id === rect.id}
                        shapeProps={{
                          ...rect,
                          width: rect.width || 100,
                          height: rect.height || 100,
                        }}
                        onSelect={() => {
                          setSelectedArt2Id(rect.id);
                        }}
                        onChange={(newAttrs) => {
                          if (newAttrs.delete) {
                            const newRectangles = rectangles.filter(
                              (r) => r && r.id !== rect.id,
                            );
                            setRectangles(newRectangles);

                            setTimeout(() => captureSnapshot(), 100);
                          } else {
                            const updatedRectangles = rectangles.slice();
                            const actualIndex = rectangles.findIndex(
                              (r) => r && r.id === rect.id,
                            );
                            if (actualIndex !== -1) {
                              updatedRectangles[actualIndex] = newAttrs;
                              setRectangles(updatedRectangles);
                              setTimeout(() => captureSnapshot(), 100);
                            }
                          }
                        }}
                        showDeleteButton={!hideDeleteButtons} // Pass the hideDeleteButtons state
                      />
                    ))}
              </>
            );
          }
          // Show raw designs (no Fabric2 applied)
          return (
            <>
              {/* Art1 design */}
              {hasArt1 &&
                rectangles
                  .filter((rect) => rect && rect.type === "art1")
                  .map((rect, index) => (
                    <Rectangle
                      key={rect.id || `art1-${index}`}
                      backgroundColor={"red"}
                      setBaseImageUrl={setBaseImageUrl}
                      isSelected={selectedArt2Id === rect.id}
                      shapeProps={{
                        ...rect,
                        width: rect.width || 100,
                        height: rect.height || 100,
                      }}
                      onSelect={() => {
                        setSelectedArt2Id(rect.id);
                      }}
                      onChange={(newAttrs) => {
                        if (newAttrs.delete) {
                          const newRectangles = rectangles.filter(
                            (r) => r && r.id !== rect.id,
                          );

                          setRectangles(newRectangles);
                          setCurrentArt1Design([]);
                          setArt1Thread([]);
                          // Clear Fabric2 when Art1 is deleted
                          setFabric2Image([]);
                          setFabric2Id("");
                          setFillImageUrl("");
                          setKonvaImage1?.(null);
                          setTimeout(() => captureSnapshot(), 100);
                        } else {
                          const updatedRectangles = rectangles.slice();
                          const actualIndex = rectangles.findIndex(
                            (r) => r && r.id === rect.id,
                          );
                          if (actualIndex !== -1) {
                            updatedRectangles[actualIndex] = newAttrs;
                            setRectangles(updatedRectangles);
                            setTimeout(() => captureSnapshot(), 100);
                          }
                        }
                      }}
                      showDeleteButton={!hideDeleteButtons} // Pass the hideDeleteButtons state
                    />
                  ))}

              {/* Art2 design */}
              {hasArt2 &&
                rectangles
                  .filter((rect) => rect && rect.type === "art2")
                  .map((rect, index) => (
                    <Rectangle
                      key={rect.id || `art2-${index}`}
                      backgroundColor={"red"}
                      setBaseImageUrl={setBaseImageUrl}
                      isSelected={selectedArt2Id === rect.id}
                      shapeProps={{
                        ...rect,
                        width: rect.width || 100,
                        height: rect.height || 100,
                      }}
                      onSelect={() => {
                        setSelectedArt2Id(rect.id);
                      }}
                      onChange={(newAttrs) => {
                        if (newAttrs.delete) {
                          const newRectangles = rectangles.filter(
                            (r) => r && r.id !== rect.id,
                          );

                          setRectangles(newRectangles);
                          setCurrentArt2Design((ds) =>
                            ds?.filter((d) => d?._id !== rect.id),
                          );
                          setArt2Thread((th) =>
                            th?.filter((tr) => tr?._id !== rect.id),
                          );
                          setTimeout(() => captureSnapshot(), 100);
                        } else {
                          const updatedRectangles = rectangles.slice();
                          const actualIndex = rectangles.findIndex(
                            (r) => r && r.id === rect.id,
                          );
                          if (actualIndex !== -1) {
                            updatedRectangles[actualIndex] = newAttrs;
                            setRectangles(updatedRectangles);
                            setTimeout(() => captureSnapshot(), 100);
                          }
                        }
                      }}
                      showDeleteButton={!hideDeleteButtons} // Pass the hideDeleteButtons state
                    />
                  ))}
            </>
          );
        })()}

        {/* 3️⃣ Render multiple text objects */}
        {textObjects?.map((textObj, index) => {
          if (!textObj?.text) return null;
          const TextComponent = textObj.shape === "straight" ? Text : TextPath;
          const alignment = textObj.textAlign || "center";
          let initialX = textObj.position?.x;
          if (!initialX) {
            switch (alignment) {
              case "left":
                initialX = 10; // Or some padding from left edge
                break;
              case "right":
                initialX = dynamicCanvasWidth - 10; // Or some padding from right edge
                break;
              case "center":
              default:
                initialX = dynamicCanvasWidth / 2;
                break;
            }
          }
          const textProps = {
            x: 5,
            y: textObj.position?.y || dynamicCanvasHeight / 2,
            text: formatMixedHebrewText(textObj.text, textObj.textAlign) || "",
            fontSize: calculateFontSize(
              textObj.text?.length || 0,
              textObj.fontSize || 48,
            ),
            fontFamily: textObj?.fontFamily || "Baziporen, sans-serif",
            fill: textObj?.color || "#FFD700",
            draggable: true,
            zIndex: 100,
            align: alignment,
            verticalAlign: "middle",
            offsetX: 0,
            offsetY: 0,
            scaleX: textObj?.scale?.x || 1,
            scaleY: textObj?.scale?.y || 1,
            rotation: textObj?.rotation || 0,
            width: dynamicCanvasWidth * 0.95,
            wrap: "word",
            fontSize: textObj?.fontSize || 48,
            // 3D Properties
            depth: textObj?.depth || 10,
            bevelEnabled: textObj?.bevelEnabled !== false,
            bevelSize: textObj?.bevelSize || 2,
            bevelThickness: textObj?.bevelThickness || 1,
            is3D: true,

            // Gradient
            fillLinearGradientStartPoint: { x: 0, y: 0 },
            fillLinearGradientEndPoint: { x: 0, y: 1 },
            fillLinearGradientColorStops: textObj?.frontGradient || [
              0,
              textObj?.color || "#FFD700",
              1,
              textObj?.color || "#CCAA00",
            ],

            // Side and Bevel Colors
            sideFill: textObj?.sideColor || textObj?.color || "#CC9900",
            bevelFill: textObj?.bevelColor || textObj?.color || "#996600",

            // Lighting
            lightDirection: textObj?.lightDirection || { x: 1, y: 1, z: 1 },
            lightIntensity: textObj?.lightIntensity || 0.7,
            ambientLight: textObj?.ambientLight || 0.3,

            // Spacing
            lineHeight: textObj?.lineHeight || 1.1,
            letterSpacing:
              textObj?.shape === "straight"
                ? Math.max(1, textObj?.letterSpacing)
                : textObj?.letterSpacing || 0,
            padding: textObj?.padding || 10,

            // 3D Perspective
            perspective: textObj?.perspective || 500,

            // Bevel & Emboss Effects via shadow simulation
            ...(() => {
              const effect = textObj?.textEffect || "none";
              if (effect === "bevel") {
                return {
                  shadowColor: "rgba(255,255,255,0.8)",
                  shadowBlur: 0,
                  shadowOffsetX: -2,
                  shadowOffsetY: -2,
                  shadowOpacity: 1,
                  stroke: "rgba(0,0,0,0.4)",
                  strokeWidth: 1,
                };
              }
              if (effect === "emboss") {
                return {
                  shadowColor: "rgba(0,0,0,0.7)",
                  shadowBlur: 3,
                  shadowOffsetX: 3,
                  shadowOffsetY: 3,
                  shadowOpacity: 0.8,
                  stroke: "rgba(255,255,255,0.5)",
                  strokeWidth: 1,
                };
              }
              if (effect === "extrude3d") {
                return {
                  shadowEnabled: false,
                };
              }
              return {
                shadowColor: textObj?.shadowColor || "rgba(0,0,0,0.5)",
                shadowBlur: textObj?.shadowBlur || 10,
                shadowOffsetX: textObj?.shadowOffset?.x || 5,
                shadowOffsetY: textObj?.shadowOffset?.y || 5,
                shadowOpacity: textObj?.shadowOpacity || 0.6,
              };
            })(),

            // Advanced Shadow Effects
            castShadow: true,
            receiveShadow: true,
            dropShadow: textObj?.dropShadow || {
              color: "rgba(0,0,0,0.5)",
              blur: 15,
              offsetX: 8,
              offsetY: 8,
              opacity: 0.5,
            },

            innerShadow: textObj?.innerShadow || {
              color: "rgba(0,0,0,0.3)",
              blur: 5,
              offsetX: 2,
              offsetY: 2,
              opacity: 0.3,
            },

            // Material Properties
            texture: textObj?.texture || null,
            textureScale: textObj?.textureScale || 1,
            metallic: textObj?.metallic || 0.3,
            roughness: textObj?.roughness || 0.7,
            // Edge Highlights
            edgeHighlight: textObj?.edgeHighlight !== false,
            edgeHighlightColor: textObj?.edgeHighlightColor || "#FFFFFF",
            edgeHighlightWidth: textObj?.edgeHighlightWidth || 0.5,
            onDragEnd: (e) => handleTextDragEnd(textObj.id, e),
            onTransformEnd: (e) => handleTextTransformEnd(textObj.id, e),
            onClick: (e) => {
              e.cancelBubble = true;
              handleTextSelect(textObj.id);
            },
            onTap: (e) => {
              e.cancelBubble = true;
              handleTextSelect(textObj.id);
            },
            ref: (ref) => {
              if (textObj.id) {
                textRefs.current[textObj.id] = ref;
              }
            },
            // Custom sceneFunc for 3D extrude and inner shadow effects
            ...(() => {
              const effect = textObj?.textEffect || "none";

              if (effect === "extrude3d" && textObj.shape === "straight") {
                return {
                  shadowEnabled: false,
                  sceneFunc: (ctx, shape) => {
                    const mainColor = String(textObj?.color || "#FF0000");
                    const depth = textObj?.extrudeDepth ?? 6;

                    // Darken the main color for the extrude layers
                    const darken = (hex, amount) => {
                      const num = parseInt(hex.replace("#", ""), 16);
                      const r = Math.max(0, (num >> 16) - amount);
                      const g = Math.max(0, ((num >> 8) & 0xff) - amount);
                      const b = Math.max(0, (num & 0xff) - amount);
                      return `rgb(${r},${g},${b})`;
                    };
                    const extrudeColor = mainColor.startsWith("#")
                      ? darken(mainColor, 80)
                      : "rgba(0,0,0,0.6)";

                    // Draw stacked offset copies (extrude layers) bottom to top
                    for (let i = depth; i >= 1; i--) {
                      ctx.save();
                      ctx.translate(i, i);
                      const origFill = shape.fill();
                      shape.fill(extrudeColor);
                      shape._sceneFunc(ctx);
                      shape.fill(origFill);
                      ctx.restore();
                    }

                    // Draw the main text on top
                    shape._sceneFunc(ctx);
                  },
                };
              }

              if (textObj?.innerShadowEnabled && textObj.shape === "straight") {
                return {
                  shadowEnabled: false,
                  sceneFunc: (ctx, shape) => {
                    const color = textObj.innerShadowColor || "#000000";
                    const blur = textObj.innerShadowBlur ?? 6;
                    const offsetX = textObj.innerShadowOffsetX ?? 3;
                    const offsetY = textObj.innerShadowOffsetY ?? 3;

                    shape._sceneFunc(ctx);

                    const w = shape.width() + Math.abs(offsetX) + blur * 2 + 20;
                    const h = shape.height() + Math.abs(offsetY) + blur * 2 + 20;
                    const offscreen = document.createElement("canvas");
                    offscreen.width = w;
                    offscreen.height = h;
                    const offCtx = offscreen.getContext("2d");

                    const px = blur + Math.abs(Math.min(offsetX, 0));
                    const py = blur + Math.abs(Math.min(offsetY, 0));

                    offCtx.save();
                    offCtx.translate(px, py);
                    shape._sceneFunc(offCtx);
                    offCtx.restore();

                    offCtx.globalCompositeOperation = "source-in";
                    offCtx.shadowColor = color;
                    offCtx.shadowBlur = blur;
                    offCtx.shadowOffsetX = offsetX;
                    offCtx.shadowOffsetY = offsetY;
                    offCtx.fillStyle = color;
                    offCtx.fillRect(0, 0, w, h);

                    offCtx.globalCompositeOperation = "destination-in";
                    offCtx.shadowColor = "transparent";
                    offCtx.shadowBlur = 0;
                    offCtx.shadowOffsetX = 0;
                    offCtx.shadowOffsetY = 0;
                    offCtx.save();
                    offCtx.translate(px, py);
                    shape._sceneFunc(offCtx);
                    offCtx.restore();

                    ctx.save();
                    ctx.translate(-px, -py);
                    ctx.drawImage(offscreen, 0, 0);
                    ctx.restore();
                  },
                };
              }

              return {};
            })(),
          };

          if (textObj.shape !== "straight") {
            textProps.data =
              textObj.shape === "arch"
                ? "M 20,150 A 100,100 0 0,1 250,150"
                : `M 0,${-(textObj.radius || 80) * 4} A ${(textObj.radius || 80) * 4
                },${(textObj.radius || 80) * 4} 0 1,0 0,${(textObj.radius || 80) * 4
                } A ${(textObj.radius || 80) * 4},${(textObj.radius || 80) * 4
                } 0 1,0 0,${-(textObj.radius || 80) * 4}`;
          }

          return (
            <React.Fragment key={textObj.id || `text-${index}`}>
              <TextComponent {...textProps} />
              {textTransformers[textObj.id] && textRefs.current[textObj.id] && (
                <Transformer
                  ref={(ref) => {
                    if (textObj.id) {
                      transformerRefs.current[textObj.id] = ref;
                    }
                  }}
                  nodes={[textRefs.current[textObj.id]]}
                  rotateEnabled={true}
                  flipEnabled={false}
                  resizeEnabled={true}
                  keepRatio={false}
                  boundBoxFunc={(oldBox, newBox) => {
                    if (Math.abs(newBox.width / oldBox.width) > 1.5) {
                      return oldBox;
                    }
                    return newBox;
                  }}
                />
              )}
            </React.Fragment>
          );
        })}
      </Layer>
    );
  };

  const normalizedCategoryTitle = (categoryData?.title || categoryData?.name || "")
    .trim()
    .toLowerCase();
  const isChallahCover =
    normalizedCategoryTitle.includes("passover") ||
    normalizedCategoryTitle.includes("pesach") ||
    normalizedCategoryTitle.includes("challah");
  const productImage = product?.images?.[0];
  const fallbackImage = isChallahCover
    ? "/passover-default.jpeg"
    : "/customize instructions.png";

  const renderCompareButtons = (isMobile = false) => (
    <div
      className={`compare-container ${isMobile ? "mobile-action-buttons d-flex d-lg-none" : "desktop-action-buttons d-none d-lg-flex"
        }`}
    >
      <button
        type="button"
        className={`${getFabricImage?.length > 0
            ? "compare-button"
            : "compare-button-disabled"
          } select-to-compare py-2`}
        onClick={() => {
          if (localStorage.getItem("token")) {
            handleExportImage("compare");
          } else {
            setExportActionType("compare");
            setLoginModalIsOpen(true);
          }
        }}
        disabled={getFabricImage?.length === 0}
      >
        Select To Compare
      </button>

      <button
        type="button"
        className={`compare py-2 ${isComparedButtonEnabled && getFabricImage?.length > 0
            ? "compare-button"
            : "compare-button-disabled"
          }`}
        disabled={!isComparedButtonEnabled}
        onClick={() => {
          if (!localStorage.getItem("token")) {
            toast.error("Please login! then go to compare page.");
            if (!isComparedButtonEnabled) {
              toast.error("No images to Compare!");
              return;
            }
            navigate("/login", {
              state: {
                locationPath: `/compare?categoryId=${categoryId}&collectionId=${collectionId}`,
                data: null,
              },
            });
          } else {
            if (!isComparedButtonEnabled) {
              toast.error("No images to Compare!");
              return;
            }
            navigate(
              `/compare?categoryId=${categoryId}&collectionId=${collectionId}&collectionName=${collectionData?.title}`,
            );
          }
        }}
      >
        Compare
      </button>

      <button
        type="button"
        className="compare-button add-to-cart"
        onClick={() => {
          if (!localStorage.getItem("token")) {
            setExportActionType("cart");
            setLoginModalIsOpen(true);
          } else {
            handleExportImage("cart");
          }
        }}
      >
        {cartBtnMsg}
      </button>
    </div>
  );
                                                                                    
  return (
    <>
      <div
        className="customize-header"
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
        }}
      >
        <nav className="mb-5 mt-2 font-poppins route-navigation">
          <ul className="d-flex gap-4 text-light-gray fs-20 fw-bold ">
            {" "}
            <li className="list-unstyled">
              <Link to={"/"}>HOME </Link>
            </li>
            <li className="list-unstyled">
              <img loading="lazy" src={rightArrow} alt="" />
            </li>
            <NavLink to={`/category?catid=${categoryData?._id || categoryId}`}>
              <li className="list-unstyled">
                {categoryData?.title}
              </li>
            </NavLink>
            <li className="list-unstyled">
              <img loading="lazy" src={rightArrow} alt="" />
            </li>
            <NavLink
              to={
                !collectionId || collectionId == "all"
                  ? `/category?catid=${categoryData?._id || categoryId}`
                  : `/category/collection?catid=${categoryData?._id || categoryId}&collectionId=${collectionId}`
              }
            >
              <li className="list-unstyled">
                {!collectionId || collectionId == "all"
                  ? "All Categories"
                  : collectionData?.title}
              </li>
            </NavLink>
            <li className="list-unstyled">
              <img loading="lazy" src={rightArrow} alt="" />
            </li>
            <NavLink
              to="#"
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              <li className="list-unstyled text-dark">Customize Product</li>
            </NavLink>
          </ul>
        </nav>
        <div className="d-flex flex-wrap gap-4 justify-content-end w-100 customize-header-actions">
          <div>
            <button
              className="compare-button"
              onClick={handleUndo}
              disabled={historyStep <= 0}
              style={{
                opacity: historyStep <= 0 ? 0.5 : 1,
                cursor: historyStep <= 0 ? "not-allowed" : "pointer",
              }}
              title="Undo (Ctrl+Z)"
            >
              ↶ Undo
            </button>
          </div>
          <div>
            <button
              className="compare-button"
              onClick={handleRedo}
              disabled={historyStep >= history.length - 1}
              style={{
                opacity: historyStep >= history.length - 1 ? 0.5 : 1,
                cursor:
                  historyStep >= history.length - 1 ? "not-allowed" : "pointer",
              }}
              title="Redo (Ctrl+Y)"
            >
              ↷ Redo
            </button>
           
          </div>
          <div>
             <button
              className="compare-button"
              onClick={() => navigate("/carts")}
              title="Cart"
            >
              <FaShoppingCart /> Cart
            </button>
          </div>
        </div>
      </div>
      <div
        className="row mt-3 w-100 flex-column flex-md-row justify-content-center mx-0 customize-main-row"
      >
        {loader && <Loader />}

        <div className="col-12 col-lg-6 d-flex customize-left-column">
          <div className="mx-auto d-flex align-items-center flex-column customize-canvas-column">
            {bgColor == null || getFabricImage?.length === 0 ? (
              <img
                loading="lazy"
                src={
                  productImage
                    ? Constants.imgDomain + productImage
                    : fallbackImage
                }
                alt="img"
                className="w-100 object-fit-contain mx-auto text-center customize-preview-image"
                style={
                  isChallahCover ? { maxHeight: "450px" } : {}
                }
              />
            ) : (
              <>
                <div
                  className="w-100 text-center fw-bold mb-2"
                  style={{ fontSize: "clamp(14px, 2vw, 18px)", color: "#1c274c" }}
                >
                  Total Price ${totalPrice}
                </div>
                <div
                  ref={containerCanvasRef}
                  className="customize-canvas-container"
                  style={{
                    width: "100%",
                    overflow: "hidden",
                    height: `${dynamicCanvasHeight * scaleCanvas}px`,
                  }}
                >
                  <Stage
                    width={dynamicCanvasWidth}
                    height={dynamicCanvasHeight}
                    scaleX={scaleCanvas}
                    scaleY={scaleCanvas}
                    style={{
                       width: `${dynamicCanvasWidth * scaleCanvas}px`,
                       height: `${dynamicCanvasHeight * scaleCanvas}px`,
                       display: "block",
                    }}
                    ref={stageRef}
                    onMouseDown={checkDeselect}
                    onTouchStart={checkDeselect}
                  >
                    {renderCanvasContent()}
                  </Stage>
                </div>
              </>
            )}
            {getFabricImage?.length > 0 && (
              <>
                <p
                  className="my-4 customize-warning-note"
                >
                  {" "}
                  Please note: Real life embroidery, colors and fonts may look
                  different than it appears on the website.
                </p>
                <textarea
                  className="form-control mt-2 mb-3 customize-notes"
                  placeholder="Add notes here..."
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  onBlur={() => setTimeout(() => captureSnapshot(), 100)}
                />
              </>
            )}

            {renderCompareButtons(false)}
          </div>
          <div className="d-flex flex-column gap-4 customize-menu-column">
            <div className="menu-container">
              {optionArr.map((item, index) => (
                <div key={index} className="menu-item-wrapper">
                  <button
                    type="button"
                    className={`menu-item-button ${activeMenuTab === item.name ? "active" : ""
                      }`}
                    onClick={() => setActiveMenuTab(item.name)}
                  >
                    {item.name}
                  </button>
                </div>
              ))}
            </div>
            {/* Mobile tab content */}
            {renderTabContent(true)}
            {renderCompareButtons(true)}
          </div>
        </div>

        {/* Desktop tab content */}
        {renderTabContent(false)}
      </div>
      {/* Only show ProductsList if we have the required URL parameters */}
      {searchParams.get("categoryId") && searchParams.get("collectionId") && (
        <ProductsList refetch={refetchProducts} />
      )}

      <canvas ref={originalCanvasRef} style={{ display: "none" }} />
      <canvas ref={modifiedCanvasRef} style={{ display: "none" }} />

      <LoginModal
        isOpen={loginModalIsOpen}
        setIsOpen={setLoginModalIsOpen}
        actionPerform={() => {
          handleExportImage(exportActionType);
        }}
      />
    </>
  );
};

export default Customize; 
